"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _Progress_1 = require("./_Progress");
exports._ProgressEvent = {
    type: "structure",
    required: [],
    members: {
        Details: {
            shape: _Progress_1._Progress
        }
    }
};
//# sourceMappingURL=_ProgressEvent.js.map